import React from "react";
import ReactDOM from "react-dom";
import App from './app';

const rootElement = document.getElementById("models-comparator-root");
const modelId = rootElement.getAttribute('data-modelId');
if (rootElement) {
    ReactDOM.render(<App modelId={modelId !== 'None' ? modelId : null} />, rootElement);
}